import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShuffle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconShuffle"><Path fillRule="evenodd" clipRule="evenodd" d="M18 2.58594L22.4142 7.00015L18 11.4144L16.5858 10.0002L18.5858 8.00015H16.4142L5.41421 19.0002H2V17.0002H4.58579L15.5858 6.00015H18.5858L16.5858 4.00015L18 2.58594ZM2 5.00015H5.41421L9.41421 9.00015L8 10.4144L4.58579 7.00015H2V5.00015ZM18 12.5859L22.4142 17.0002L18 21.4144L16.5858 20.0002L18.5858 18.0002H15.5858L12.5858 15.0002L14 13.5859L16.4142 16.0002H18.5858L16.5858 14.0002L18 12.5859Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShuffle;
